import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import CallTakerServices from "@/CADServices/APIs/callTaker";
import { useQuery } from 'react-query';

const styles = {
    wrap: {
        display: 'flex',
        border: '1px solid #b8d4eb',
        borderRadius: '4px',
        overflow: 'hidden',
        background: '#f0f7fc',
        minWidth: 0,
        marginTop: '8px',
    },
    accentBar: {
        width: '6px',
        flexShrink: 0,
        background: '#1565c0',
    },
    inner: {
        flex: 1,
        minWidth: 0,
        padding: '10px 12px',
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '10px',
    },
    buildingIcon: {
        color: '#1565c0',
        fontSize: '18px',
    },
    titleGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
    },
    title: {
        margin: 0,
        fontWeight: 700,
        fontSize: '16px',
        letterSpacing: '0.02em',
        color: '#0d47a1',
        textTransform: 'uppercase',
    },
    countBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '22px',
        height: '22px',
        padding: '0 6px',
        borderRadius: '999px',
        background: '#1976d2',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 700,
    },
    infoBox: {
        marginBottom: '12px',
        padding: '10px 12px 10px 14px',
        background: '#e3f2fd',
        borderLeft: '4px solid #1565c0',
        borderRadius: '2px',
        fontSize: '13px',
        lineHeight: 1.45,
        color: '#1a3a5c',
    },
    infoStrong: {
        fontWeight: 700,
        color: '#0d47a1',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13px',
    },
    thRow: {
        background: '#d6eafa',
    },
    th: {
        textAlign: 'left',
        padding: '8px 10px',
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.04em',
        color: '#0d47a1',
        textTransform: 'uppercase',
        borderBottom: '1px solid #b8d4eb',
    },
    thAction: {
        textAlign: 'right',
    },
    td: {
        padding: '10px',
        verticalAlign: 'middle',
        borderBottom: '1px solid #cfe8f7',
        background: '#fff',
    },
    tdUnit: {
        fontWeight: 700,
        color: '#1565c0',
    },
    tdMuted: {
        color: '#546e7a',
    },
    zoneCode: {
        color: '#546e7a',
        fontWeight: 500,
    },
    zoneRelation: {
        color: '#b85c14',
        fontWeight: 600,
    },
    tdAction: {
        textAlign: 'right',
    },
    dispatchBtn: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px 16px',
        borderRadius: '6px',
        border: 'none',
        background: '#1976d2',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 700,
        cursor: 'pointer',
    },
    dispatchBtnDisabled: {
        opacity: 0.55,
        cursor: 'not-allowed',
        background: '#90a4ae',
    },
};

function OtherAid({
    fireZone,
    runCardData,
    resourceDropDown,
    setResourceDropDown,
    otherZoneFireResourcesData,
    setOtherZoneFireResourcesData,
    resource1Selection = [],
    onDispatchOtherAidResource,
}) {
    const ResourceTypeIDs = [...new Set(
        (runCardData ?? [])
            .filter((item) => String(item?.Status ?? '').toUpperCase() !== 'AV')
            .map((item) => item?.ResourceTypeID)
            .filter((id) => id != null && id !== '')
    )].join(',');
    const getOtherZoneFireResourcesKey = `/CAD/GeoPetrolZone/GetOtherZoneFireResources/${fireZone}`;
    const { data: otherZoneFireResourcesDataQuery, isSuccess: isFetchOtherZoneFireResourcesData } =
        useQuery(
            [getOtherZoneFireResourcesKey, { ExcludeFireZoneID: fireZone, ResourceTypeIDs: ResourceTypeIDs }],
            CallTakerServices.getOtherZoneFireResources,
            {
                refetchOnWindowFocus: false,
                enabled: !!fireZone && !!ResourceTypeIDs
            }
        );

    useEffect(() => {
        if (isFetchOtherZoneFireResourcesData && otherZoneFireResourcesDataQuery) {
            const data = JSON.parse(otherZoneFireResourcesDataQuery?.data?.data);
            setOtherZoneFireResourcesData(data?.Table);
        } else {
            setOtherZoneFireResourcesData([]);
        }
    }, [isFetchOtherZoneFireResourcesData, otherZoneFireResourcesDataQuery, setOtherZoneFireResourcesData]);

    const selectedResource1Ids = new Set(
        (Array.isArray(resource1Selection) ? resource1Selection : [])
            .map((r) => Number(r?.ResourceID))
            .filter((n) => Number.isFinite(n) && n !== 0),
    );

    return (
        <>
            {otherZoneFireResourcesData?.length > 0 && (
                <div className="mt-2" style={styles.wrap}>
                    <div style={styles.accentBar} aria-hidden />
                    <div style={styles.inner}>
                        <div style={styles.headerRow}>
                            <FontAwesomeIcon icon={faBuilding} style={styles.buildingIcon} />
                            <div style={styles.titleGroup}>
                                <h2 style={styles.title}>Other stations</h2>
                                <span style={styles.countBadge} aria-label={`${otherZoneFireResourcesData?.length} units`}>
                                    {otherZoneFireResourcesData?.length}
                                </span>
                            </div>
                        </div>

                        {/* <div style={styles.infoBox} role="note">
                    Available units from sister stations matching the missing apparatus types (
                    <strong style={styles.infoStrong}>{missingApparatus}</strong>
                    ). Sorted by proximity to incident zone <strong style={styles.infoStrong}>{incidentZone}</strong>.
                </div> */}

                        <table style={styles.table}>
                            <thead>
                                <tr style={styles.thRow}>
                                    <th style={styles.th}>Unit</th>
                                    <th style={styles.th}>Type</th>
                                    <th style={styles.th}>Zone</th>
                                    <th style={{ ...styles.th, ...styles.thAction }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {otherZoneFireResourcesData?.length > 0 && otherZoneFireResourcesData?.map((row) => {
                                    const rid = Number(row?.ResourceID);
                                    const isDispatched = Number.isFinite(rid) && selectedResource1Ids.has(rid);
                                    return (
                                        <tr key={row.ResourceID}>
                                            <td style={{ ...styles.td, ...styles.tdUnit }}>{row.ResourceNumber}</td>
                                            <td style={{ ...styles.td, ...styles.tdMuted }}>{row.ResourcesType}</td>
                                            <td style={{ ...styles.td, ...styles.tdMuted }}>{row.ZoneDescription}</td>
                                            <td style={{ ...styles.td, ...styles.tdAction }}>
                                                <button
                                                    type="button"
                                                    disabled={isDispatched}
                                                    style={{
                                                        ...styles.dispatchBtn,
                                                        ...(isDispatched ? styles.dispatchBtnDisabled : {}),
                                                    }}
                                                    onClick={() => onDispatchOtherAidResource?.(row)}
                                                >
                                                    Dispatch
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
}

export default OtherAid;
